import React from "react";
import { connect } from "react-redux";
import { blockUi, resetStore, unBlockUi } from "../../actions/actionCreator";
import { sowCaseStatus } from "../../constants";
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../restClient';
import { Translations, convertStringToArray, convertStringToArrayForRadio, isEmptyObject, } from "../../utils";
import {
    AddOwnerModal,
    CancelCaseModal,
    DraftGenerationSucessModal,
    SendToClientModal,
    ShareCaseConfirmation,
    SubmitRequestModal,
} from '../CaseBody/Modals';
import { enableTab, hidePreviewAndGenerateDocBtns, setCaseOwner, setCurrentActiveTab, setGenrateDoc, setLandingActiveTab, showPreviewAndGenerateDocBtns } from "../CaseBody/actions/actionCreator";
import CaseBodyFooter from '../common/CaseBodyFooter';
import CaseMenu from "../common/CaseMenu/CaseMenu";
import { caseMenuInfo, resetCaseMenuInfo } from '../common/CaseMenu/actions/actionCreator';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../common/Modal';
import Panel from "../common/Tabs/Panel";
import Tabs from "../common/Tabs/Tabs";
import { setSavedSow, setSowEntities } from "../createASow/actions/actionCreator";
import { setDarkTitleBarContent } from "../layouts/actions/actionCreator";
import AddViewComments from "./AddViewComments";
import CustomerDetails from "./CustomerDetails";
import GLSProduct from "./GLSProduct";
import SowDocumentation from "./SowDocumentation";
import { setSowBodyCustomerActiveTabIndex } from "./actions/actionCreator";
import "./index.css";

class SowBody extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showSubmitRequestModalDialog: false,
            caseIdsForDraftGeneration: [],
            showCancelCaseModalDialog: false,
            openSendToClientModalDialog: false,
            openSendToClientModalConfirmationDialog: false,
            openAddOwnerModalConfirmationDialog: false,
            showDraftGenerationSuccessModal: false,
            casesToBeCancelled: {},
            sentToClient: {},
            checkedvlaue: false,
            minNoOfCasesSelected: false,
            minNoOfClientCasesSelected: undefined,
            resetStateVals: undefined,
            cancelReasonListed: false,
            checkedOptionvalue: false,
            cancelReason: '',
            displayUserData: [],
            _displaySelectedUser: '',
            glsSubmitToCiChecker: {},
            glsApprovalCommentsJson: {},
            showCommentsModal: false,
            currentProductComments: [],
            sowTabStatus: {},
            btnDisabled: false,
            documentationConfirmationJson: {},
            sowDocData: [],
            isCustAck: false
        };
        this.payLoad = {};
        this.caseId = [];
        this.lang = {}
    }
    componentDidMount() {
        let heading;
        let transaltedText;
        // window.sessionStorage.setItem('casesForRefresh', this.props.cases);
        // window.localStorage.setItem('owningCase', this.props.owningCase.caseId);
        // let isItem = window.sessionStorage.getItem("isItem");
        // if (isItem !== null) {
        //     window.sessionStorage.removeItem("isItem");
        // }
        aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {

                let bodyHeading = this.props.sowEntities.filter(entity => {
                    return entity.agent
                })

                if (this.props.sowDetail.statusValue === 'Cancelled' || this.props.sowDetail.statusValue === 'Acknowledged By Customer' || this.props.sowDetail.statusValue === 'Sent to Implementation Manager') {

                    this.setState({ btnDisabled: true });
                }
                if (this.props.sowDetail.statusValue === 'Acknowledged By Customer' || this.props.sowDetail.statusValue === 'Sent to Implementation Manager') {

                    this.setState({ isCustAck: true });
                }
                transaltedText = Translations(data.par.static_text_darkTitleBar.exitSow, this.props.lang.currentLang.lang, this.props.lang.translatedData);
                taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
                    .then(({ data }) => {
                        if (bodyHeading && bodyHeading[0] && bodyHeading[0].registeredName) {
                            this.props.setDarkTitleBarContent(bodyHeading[0].registeredName, true, transaltedText, "icon icon-delete",
                                this.props.owningCase, data.responseData.classificationNodes[0].associations);
                        }
                    })
            });
        // this.fireFooterBtnRules(this.props);

        // if (Object.keys(this.props.cases).length === 1) {
        //     this.setState({ minNoOfCasesSelected: true });
        // }

        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        if (agentDetail && agentDetail[0] && agentDetail[0].groupId) {
            eapiClient('/sows/' + agentDetail[0].groupId + '/sow-owner')
                .then(({ data }) => {
                    this.props.setCaseOwner(data.responseData);
                    this.setState({
                        ...this.state,
                        displayUserData: data.responseData
                    })
                });

            eapiClient('/sows/' + agentDetail[0].groupId + '/comment')
                .then(({ data }) => {
                    // this.props.setCaseOwner(data.responseData);
                    this.setState({
                        ...this.state,
                        currentProductComments: data.responseData
                    })
                });
        }
    }
    componentWillReceiveProps(nextProps) {
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        if (nextProps.activeTabId !== this.props.activeTabId) {
            //  this.fireFooterBtnRules(nextProps);
            eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
                .then(({ data }) => {
                    //this.setState({RefreshData :data.responseData })
                    this.props.caseMenuInfo(data.responseData)
                });
        }
        // if (Object.keys(nextProps.cases).length === 1) {
        //   this.setState({ minNoOfCasesSelected: true });
        // }
        // if (this.props.lang !== nextProps.lang) {
        //   let heading;
        //   let transaltedText;

        //   aemHostClient("/aemData/formData/json_dark-title-bar")
        //     .then(({ data, status }) => {

        //       if (Object.keys(this.props.cases).length >= 1) {
        //         const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
        //         heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${Translations(data.par.static_text_darkTitleBar.others, this.props.lang.currentLang.lang, this.props.lang.translatedData)}${')'}` : ''}`;
        //       } else {
        //         heading = `${this.props.owningCase.entityName}`;
        //       }

        //       transaltedText = Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData);
        //       taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
        //         .then(({ data }) => {
        //           this.props.setDarkTitleBarContent(heading, true, transaltedText, "icon icon-delete", this.props.owningCase, data.responseData.classificationNodes[0].associations);
        //         })
        //     });
        // }
    }

    isReadOnly = (onlyIsEditing) => {
        if (onlyIsEditing) {
            return (this.props.caseMenu && this.props.caseMenu.isEditing &&
                (this.props.caseMenu.editingUserEmail !== this.props.userDetail.emailAddress))
        }
        return this.props.customer || this.state.isCustAck || (this.props.caseMenu && this.props.caseMenu.isEditing &&
            (this.props.caseMenu.editingUserEmail !== this.props.userDetail.emailAddress))
    }

    componentWillMount() {

        aemHostClient("/aemData/formData/json_cancel-case")
            .then(({ data }) => {
                this.setState({ cancelCaseModalPageJson: data });
            });
        aemHostClient("/aemData/formData/json_add-owner-page")
            .then(({ data }) => {
                this.setState({ formJsonAddOwner: data });
            });
        /*===================Product request modal page json =================*/
        aemHostClient("/aemData/formData/json_product-requests")
            .then(({ data }) => {
                this.setState({ productRequestJson: data.par })
            });
        /*===================Documentation confirmation modal page json =================*/
        aemHostClient("/aemData/formData/json_documentation-confirmation")
            .then(({ data }) => {
                this.setState({ documentationConfirmationJson: data.par })
            });

        /*===================Send Invite popup page json =================*/
        aemHostClient("/aemData/formData/json_invite-others-to-collaborate")
            .then(({ data }) => {
                this.setState({ formJsonClientToSend: data });
            });
        /*===================Invite Sent popup page json =================*/
        aemHostClient("/aemData/formData/json_your-invite-was-sent")
            .then(({ data }) => {
                this.setState({ formJsonInviteSent: data });
            });
        aemHostClient("/aemData/formData/json_gls-submit-to-ci-checker")
            .then(({ data }) => {
                this.setState({ glsSubmitToCiChecker: data.par });
            });
        this.getTabStatus()
        this.getDocStatus()

        if (this.props.sowEntitiesFromProductMapping && this.props.sowEntitiesFromProductMapping.length) {
            this.props.setSowEntities([])
        }
        this.getGlsSowCommentJson()
        this.getCustomerDetailsJson()
    }

    componentWillUnmount() {
        this.props.resetCaseMenuInfo()
    }

    getDocStatus = () => {
        eapiClient('/sows/' + this.props.sowDetail.id + '/sow-doc-status')
            .then(({ data }) => {
                if (data.responseData && data.responseData.length) {
                    this.setState({
                        sowDocData: data.responseData,
                    })
                    const sowDocData = data.responseData[0]
                    if (sowDocData && sowDocData.status && (sowDocData.status.toLowerCase() === sowCaseStatus.acknowledgedByCustomer.value.toLowerCase() ||
                        sowDocData.status.toLowerCase() === sowCaseStatus.sentToImplementationManager.value.toLowerCase())) {
                        this.props.setCurrentActiveTab(2)
                    }
                }
            })
    }

    getTabStatus = () => {
        const apiUrl = `/sows/${this.props.sowId}/sow-status`
        eapiClient(apiUrl).then(({ data }) => {
            if (data.responseData) {
                this.setState({ sowTabStatus: data.responseData })
            }
        });
    }

    getSowDetails = () => {
        this.props.blockUi && this.props.blockUi()
        eapiClient('/sows/' + this.props.sowId + '/sow-detail?isStatus=true')
            .then(({ data, status }) => {
                if (data.responseData) {
                    this.props.setSavedSow(data.responseData);
                    this.props.unBlockUi && this.props.unBlockUi()
                    aemHostClient("/aemData/formData/json_dark-title-bar")
                        .then(({ data, status }) => {

                            let bodyHeading = this.props.sowEntities.filter(entity => {
                                return entity.agent
                            })
                            let transaltedText = Translations(data.par.static_text_darkTitleBar.exitSow, this.props.lang.currentLang.lang, this.props.lang.translatedData);
                            taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
                                .then(({ data }) => {
                                    if (bodyHeading && bodyHeading[0] && bodyHeading[0].registeredName) {
                                        this.props.setDarkTitleBarContent(bodyHeading[0].registeredName, true, transaltedText, "icon icon-delete",
                                            this.props.owningCase, data.responseData.classificationNodes[0].associations);
                                    }
                                })
                            if (data.sowId) {
                                localStorage.setItem("sowId", data.sowId)
                            }
                        });
                }
            })
    }

    translateWord = (word) => {
        const currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
        const convertedArray = convertStringToArray(currentWord);
        return convertedArray;
    }

    //Cancel sow functionality
    openCancelCaseModalDialog = () => {
        this.setState({ showCancelCaseModalDialog: true });
        this.setState({ cancelReason: '' });
        this.setState({ isDisable: true });
    }

    toggleCancelCaseDialog = () => {
        this.setState({
            showCancelCaseModalDialog: false,
            casesToBeCancelled: {},
            minNoOfCasesSelected: false,
            cancelReasonListed: false
        });
    }

    /*Cancel Case Modal Callbacks*/
    _onCancelCase = () => {

        var casesToBeCancelled = []
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        casesToBeCancelled.push(agentDetail[0].groupId)
        this.payLoad.cancelReason = this.state.cancelReason;
        this.payLoad.caseIds = casesToBeCancelled;
        eapiClient('/sows/cancelSow', {
            method: 'PUT',
            data: JSON.stringify(this.payLoad)
        })
            .then(({ data }) => {
                this.setState({ showCancelCaseModalDialog: false }, () => {
                    this.lang = this.props.lang;
                    this.props.resetStore(this.lang);
                    this.props.setLandingActiveTab(1);
                    this.props.history.push('/case-list');
                })
            });
    }

    setRadioSelection = (value, name) => {
        this.setState({ cancelReason: value });
    }
    checkedOptions = (event) => {
        var casesToBeCancelled = { ...this.state.casesToBeCancelled };
        if (event.target.checked) {
            casesToBeCancelled[event.target.name.split("-").pop()] = true;
        } else {
            casesToBeCancelled[event.target.name.split("-").pop()] = false;
        }
        var minNoOfCasesSelected = this.casesSelectedForCancellation(casesToBeCancelled);
        this.setState({ casesToBeCancelled, minNoOfCasesSelected });
    }
    checkboxStatus = (event) => {
        if (event.target.checked === true && (this.state.cancelReason !== '' || this.state.cancelReason !== undefined)) {
            this.setState({ cancelReasonListed: true, minNoOfCasesSelected: true });
        } else {
            this.setState({ cancelReasonListed: false });
        }
    }

    ////// add/ update owner modal  ///////////

    openAddOwnerModalDialog = () => {
        this.setState({ openAddOwnerModalDialog: true })
    }
    translateWordForRadio = (word) => {
        var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
        var convertedArray = convertStringToArrayForRadio(currentWord);
        return convertedArray;
    }
    translations = (text) => {
        return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }
    toggleDialog = (cb) => {
        cb !== undefined && typeof (cb) === "string" ? document.getElementById(cb).focus() : '';
        this.setState({
            openSendToClientModalDialog: false,
            showSubmitRequestModalDialog: false,
            showDraftGenerationSuccessModal: false,
            openSendToClientModalConfirmationDialog: false,
            openAddOwnerModalDialog: false,
            displaySelectedUser: '',
            userRoll: '',
            resetStateVals: true,
            sentToClient: {},
            caseIdsForDraftGeneration: [],
            minNoOfClientCasesSelected: undefined
        }, () => {
            if (cb && typeof (cb) === "function") {
                cb();
            }
        });
    }

    getSelectedUser = (selectedUser) => {
        if (!this.state.displayUserData.find(item => selectedUser.id === item.id)) {
            this.setState({
                ...this.state,
                displaySelectedUser: selectedUser.name,
                selectedUser: selectedUser
            })
            //this.setState({displayUserData: this.state.displayUserData.concat([selectedUser]).reverse()});
        }
    }

    setOwnerRoll = (value) => {
        this.setState({
            ...this.state,
            userRoll: value
        })
    }


    getsowId = () => {
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        return agentDetail && agentDetail[0] && agentDetail[0].groupId
    }

    submitOwner = () => {

        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        let payload = new OwnerListData(this.state);
        payload.ownerPayLoad(this.state);
        payload.data.status = "urn:hsbc:cmb:gdocs:case:taxonomies:status:active"

        const apiURL = "/sows/" + agentDetail[0].groupId + "/sow-owner";
        eapiClient(apiURL, {
            method: 'PUT',
            data: JSON.stringify(payload.data)
        })
            .then(({ data }) => {
                this.props.setCaseOwner(data.responseData);
                this.setState({
                    ...this.state,
                    displayUserData: data.responseData,
                    displaySelectedUser: '',
                    userRoll: '',
                    openAddOwnerModalDialog: false
                })
                eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
                    .then(({ data }) => {
                        this.props.caseMenuInfo(data.responseData)
                    });
            })

    }

    deleteAddedOwner = (event) => {
        let filterData = this.state.displayUserData.filter(item => item.email === event.target.getAttribute('data-key'))
        let payload = new OwnerListData(filterData[0]);
        payload.ownerDelteedPayLoad(filterData[0]);
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        payload.deleteData.status = "urn:hsbc:cmb:gdocs:case:taxonomies:status:delete"
        const apiURL = "/sows/" + agentDetail[0].groupId + "/sow-owner";
        eapiClient(apiURL, {
            method: 'PUT',
            data: JSON.stringify(payload.deleteData)
        })
            .then(({ data }) => {
                this.props.setCaseOwner(data.responseData);
                this.setState({
                    ...this.state,
                    displayUserData: data.responseData
                })
                eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
                    .then(({ data }) => {
                        this.props.caseMenuInfo(data.responseData)
                    });
            })
    }

    //share to customer modal call backs

    sentToClientCheckedOptions = (event) => {
        var sentToClient = { ...this.state.sentToClient };
        if (event.target.checked) {
            sentToClient[event.target.name.split("-").pop()] = true;
        } else {
            sentToClient[event.target.name.split("-").pop()] = false;
        }
        var minNoOfClientCasesSelected = this.casesSelectedForSentToClient(sentToClient);
        this.setState({
            sentToClient,
            minNoOfClientCasesSelected,
            resetStateVals: false
        });
    }
    onFormSubmitClientToSend = (data) => {
        var payLoad = {};
        payLoad.firstName = data.firstName
        payLoad.lastname = data.lastName
        payLoad.email = data.email
        payLoad.language = { name: data.language, value: data.language }
        let caseIds = [];
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })
        let sowId = agentDetail[0].groupId
        caseIds.push(sowId.toString())
        payLoad.caseIds = caseIds

        if (data.firstName !== "" && data.lastName !== "" && data.email !== "" && data.language !== "") {
            eapiClient("/sows/shareSow", {
                method: 'POST',
                timeout: 30000,
                data: JSON.stringify(payLoad)
            })
                .then(({ data, status, headers }) => {
                    this.toggleDialog()
                    eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
                        .then(({ data }) => {
                            //this.setState({RefreshData :data.responseData })
                            this.props.caseMenuInfo(data.responseData)
                        });
                    if (status === 200) {
                        this.getSowDetails();
                        //const token = headers["x-auth-token"];
                        this.setState({ openSendToClientModalConfirmationDialog: true });
                        //const {userDetails, lastLogin} = data.responseData;
                        //this.props.logInUser(true, token,  data.responseData.principal, new Date(), '/case-list');
                        //this.props.history.push(this.state.from || '/case-list');
                    }
                })
                .catch((error) => {
                    if (error && error.response && error.response.status === 401) {
                        this.setState({ showUnAuthorised: true });
                    }
                });
        } else {
            //alert("please fill all mandatory fields");
        }
    }
    getFormDataClientToSend = (formData) => {
        this.setState({ formData });
    }
    onFormCancelClientToSend = () => {
        this.toggleDialog();
    }
    openSendToClientModalDialog = () => {
        this.setState({ openSendToClientModalDialog: true });
    }

    openSendToCIModalDialog = () => {
        this.setState({ openSendToCIModalDialog: true });
    }
    // Toggle submit to Checker Modal
    toggleSubmitToChekerModal = () => {
        this.setState({
            openSendToCIModalDialog: false
        });
    }
    // payload to submit to checker
    _onSubmitToChecker = (email) => {
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })

        var payLoad = {};
        payLoad.email = email
        payLoad.sowId = agentDetail[0].groupId
        eapiClient(`/sows/shareSowCI`, {
            method: 'POST',
            data: JSON.stringify(payLoad)
        })
            .then(({ data, status }) => {
                this.setState({ openSendToCIModalDialog: false });
                this.getSowDetails();
            });
    }

    postComment = (productId, comment) => {
        let payLoad = {};
        let payloadArray = [];
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })

        payLoad.commentText = comment
        payLoad.username = this.props.userDetail.username
        payLoad.email = this.props.userDetail.emailAddress
        payLoad.sowId = agentDetail[0].groupId
        payloadArray.push(payLoad);
        this.props.blockUi && this.props.blockUi()
        eapiClient(`/sows/addComment`, {
            method: 'PUT',
            data: JSON.stringify(payloadArray)
        }).then(({ data }) => {
            this.props.unBlockUi && this.props.unBlockUi()
            if (Array.isArray(data.responseData)) {
                this.setState({ currentProductComments: data.responseData.filter(comment => !comment.customer) });
            }
        });
    }

    getStatusLabel = (sowTabStatus, key = "", index = 0, subTabIndex = -1, returnType = "status", toBool = true) => {
        if (!isEmptyObject(sowTabStatus) && sowTabStatus[key]) {
            if (subTabIndex > -1) {
                if (sowTabStatus[key][index] &&
                    sowTabStatus[key][index].subTab && sowTabStatus[key][index].subTab[subTabIndex] &&
                    sowTabStatus[key][index].subTab[subTabIndex] &&
                    sowTabStatus[key][index] &&
                    sowTabStatus[key][index].subTab && returnType in sowTabStatus[key][index].subTab[subTabIndex] &&
                    sowTabStatus[key][index].subTab[subTabIndex]
                ) {
                    if (returnType === "status") {
                        return sowTabStatus[key][index].subTab[subTabIndex] &&
                            sowTabStatus[key][index].subTab[subTabIndex][returnType] === "complete" ? true : false
                    } else {
                        return sowTabStatus[key][index].subTab[subTabIndex][returnType]
                    }
                }
            }
            else if (sowTabStatus[key][index] && returnType in sowTabStatus[key][index]) {
                if (returnType === "status") {
                    if (toBool === false) {
                        return sowTabStatus[key][index][returnType]
                    }
                    return sowTabStatus[key][index][returnType] === "complete" ? true : false
                }
                else {
                    return sowTabStatus[key][index][returnType]
                }
            }
        }
        return false
    }

    //Generate doc functionality
    openSubmitRequestModalDialog = () => {
        // eapiClient('/sows/urn:uuid:17d6e471c13342e3b65c5224e23604fd/sow/generate-doc/')
        //     .then(({ data }) => {
        //         //this.setState({RefreshData :data.responseData })
        //         this.props.setGenrateDoc(data.responseData)
        //         this.setState({ showSubmitRequestModalDialog: true });
        //     });
        this._onGenerateDraftClick();
        // this.setState({ showSubmitRequestModalDialog: true });
    }

    _onGenerateDraftClick = () => {
        this.toggleDialog();
        this.props.blockUi();
        this.generateDraftDocumentation(this.props.sowId, () => {
            clearInterval(this.cancelDocStatusPoll);
            this.props.unBlockUi();
            this.setState({ showDraftGenerationSuccessModal: true });
        });
    }

    generateSowDocumentwithPollApi = () => {
        this.props.blockUi();
        this.generateDraftDocumentation(this.props.sowId, () => {
            clearInterval(this.cancelDocStatusPoll);
            this.props.unBlockUi();
        });
    }

    /*Generate Documentation Case Modal Callbacks*/
    generateDraftDocumentation = (sowId, cb) => {
        eapiClient('/sowPDFGeneration/' + sowId + '/generateSowPDFDocument')
            .then(({ data }) => {
                this.cancelDocStatusPoll = setInterval(() => {
                    eapiClient('sows/' + sowId + '/sow-poll-generate-draft', {
                        noBlocking: true,
                        method: "GET"
                    })
                        .then(({ data, status }) => {
                            if (status === 201) {
                                cb();
                            }
                        })
                        .catch(error => {
                            clearInterval(this.cancelDocStatusPoll);
                        });
                }, 5000);
            });
    }

    _onOk = () => {
        this.props.enableTab("documentationTab");
        this.props.setCurrentActiveTab(2);
        let agentDetail = this.props.sowEntities.filter(entity => {
            return entity.agent
        })

        eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
            .then(({ data }) => {
                this.props.caseMenuInfo(data.responseData)
            });
        this.getDocStatus()
        this.toggleDialog();
    }

    isCustomer = () => {
        return this.props.customer
    }

    getGlsSowCommentJson = () => {
        aemHostClient("/aemData/formData/json_sow-gls-approval-comments")
            .then(({ data }) => {
                if (data.par) {
                    this.setState({ glsApprovalCommentsJson: data.par });
                }
            });
    }

    getCustomerDetailsJson = () => {
        aemHostClient("/aemData/formData/json_sow-customer-details")
            .then(({ data }) => {
                if (data.par) {
                    this.setState({ pageJson: data.par });
                }
            });
    }

    render() {
        let caseBodyJsx;
        if (this.state.pageJson === undefined || this.state.cancelCaseModalPageJson === undefined || this.state.formJsonAddOwner === undefined ||
            this.state.formJsonInviteSent === undefined || this.state.formJsonClientToSend === undefined || this.state.productRequestJson === undefined ||
            this.state.sowDocData === undefined || isEmptyObject(this.state.sowTabStatus)) {
            caseBodyJsx = (<h3>Loading...</h3>);
        } else {
            caseBodyJsx = (
                <React.Fragment>
                    <article className="case-body-main-container">
                        <article className="left-case-body-container">
                            <Tabs
                                selected={this.props.tabs.activeTabId}
                                useReduxHandler={true}
                                setCurrentActiveTab={this.props.setCurrentActiveTab}
                                ariaSelected={this.props.tabs.activeTabId}
                            >
                                <Panel
                                    label={this.translateWord(this.state.pageJson.tab_pageTab.text)[0]}
                                    status={this.getStatusLabel(this.state.sowTabStatus, "tab", 0)}
                                    disabled={this.state.btnDisabled || this.isCustomer()}
                                >
                                    <CustomerDetails
                                        history={this.props.history}
                                        customerPageJson={this.state.pageJson}
                                        entities={this.props.sowEntities.map(entity => ({ ...entity, entityName: entity.registeredName }))}
                                        lang={this.props.lang}
                                        tabs={{
                                            activeTabId: this.state.customerDetailsTabActiveIndex,
                                            customerDetailsTab: { isComplete: false, disabled: false },
                                            accountDetailsTab: { isComplete: false, disabled: false }
                                        }}
                                        setCurrentActiveTab={(entityIndex = 0, tabIndex = 0) => {
                                            const newActiveTab = { ...this.state.customerDetailsTabActiveIndex }
                                            newActiveTab[entityIndex] = { ...newActiveTab[entityIndex], activeSubTab: tabIndex }
                                            this.setState({ customerDetailsTabActiveIndex: newActiveTab })
                                        }}
                                        translateWord={this.translateWord}
                                        blockUi={this.props.blockUi}
                                        unBlockUi={this.props.unBlockUi}
                                        getSowDetails={this.getSowDetails}
                                        getTabStatus={this.getTabStatus}
                                        sowTabStatus={this.state.sowTabStatus}
                                        getStatusLabel={this.getStatusLabel}
                                        btnDisabled={this.state.btnDisabled}
                                        activeCustomerAccordionIndex={this.props.activeCustomerAccordionIndex}
                                        setSowBodyCustomerActiveTabIndex={this.props.setSowBodyCustomerActiveTabIndex}
                                        customer={this.props.customer}
                                        isCustAck={this.state.isCustAck}
                                        isReadOnly={this.isReadOnly}
                                    />
                                </Panel>
                                <Panel
                                    label={this.translateWord(this.state.pageJson.tab_pageTab.text)[1]}
                                    status={this.getStatusLabel(this.state.sowTabStatus, "tab", 1)}
                                    disabled={this.state.btnDisabled || this.isCustomer()}
                                >
                                    {this.state.sowTabStatus && this.state.sowTabStatus.glsProductStatus ?
                                        <GLSProduct
                                            history={this.props.history}
                                            productRequestJson={this.state.productRequestJson}
                                            lang={this.props.lang}
                                            tabs={{
                                                activeTabId: this.state.customerDetailsTabActiveIndex, customerDetailsTab: { isComplete: false, disabled: false },
                                                accountDetailsTab: { isComplete: false, disabled: false }
                                            }}
                                            setCurrentActiveTab={(index) => { this.setState({ customerDetailsTabActiveIndex: index }) }}
                                            translateWord={this.translateWord}
                                            entities={this.props.sowEntities.map(entity => ({ ...entity, entityName: entity.registeredName }))}
                                            sowTabStatus={this.state.sowTabStatus}
                                            sowId={this.props.sowId}
                                            getSowDetails={this.getSowDetails}
                                            getTabStatus={this.getTabStatus}
                                            customer={this.props.customer}
                                            isCustAck={this.state.isCustAck}
                                            isReadOnly={this.isReadOnly}
                                        /> : null}
                                </Panel>
                                <Panel
                                    label={this.translateWord(this.state.pageJson.tab_pageTab.text)[2]}
                                    status={this.state.isCustAck}
                                    disabled={this.state.sowDocData && this.state.sowDocData[0] && this.state.sowDocData[0].outPutPackURL === undefined ? true : false}
                                >
                                    <SowDocumentation
                                        lang={this.props.lang}
                                        caseMenu={this.props.caseMenu}
                                        sowObjId={this.props.sowDetail.id}
                                        getTabStatus={this.getTabStatus}
                                        customer={this.props.customer}
                                        sowId={this.props.sowId}
                                        userDetail={this.props.userDetail}
                                        generateSowDocumentwithPollApi={this.generateSowDocumentwithPollApi}
                                        sowDocData={this.state.sowDocData}
                                        getDocStatus={this.getDocStatus}
                                        isReadOnly={this.isReadOnly}
                                    />
                                </Panel>
                            </Tabs>
                            <section className="right-case-body-container">
                                {this.props.sowEntities ?
                                    <CaseMenu
                                        history={this.props.history}
                                        caseId={this.props.owningCase.caseId || "urn:uuid:c4577fbba69c4b8894796c08975fced6"}
                                        _getData={this.state.RefreshData}
                                        lang={this.props.lang}
                                        productType="gls-sow-body"
                                        sow
                                        sowEntities={this.props.sowEntities}
                                    /> : null
                                }
                            </section>
                        </article>
                        <CaseBodyFooter bsClass="case-body-footer-container">
                            <div className={this.isCustomer() ? 'sow-body-footer-flex-container__customer' : 'sow-body-footer-flex-container'}>
                                {this.isCustomer() ? null :
                                    <div className='sow-body-footer'>
                                        {this.props.customer ? null : <button
                                            className="gdocs-btn-default cancel"
                                            id="cancel_case"
                                            onClick={this.openCancelCaseModalDialog}
                                            disabled={this.state.btnDisabled || this.state.isCustAck || this.isReadOnly(true)}
                                        >
                                            {Translations(this.state.pageJson.button_sowCancelCase.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                                        </button>}
                                        {this.props.customer ? null :
                                            <button
                                                className="gdocs-btn-default gdocs-btn-wrap btn-li btn-padding"
                                                onClick={() => {
                                                    this.setState({
                                                        showCommentsModal: true
                                                    })
                                                }}
                                                disabled={this.state.btnDisabled || this.isReadOnly()}
                                            >
                                                Add/View Comment
                                            </button>
                                        }
                                        {this.props.customer ? null :
                                            <button
                                                className="gdocs-btn-default gdocs-btn-wrap btn-li btn-padding"
                                                onClick={this.openAddOwnerModalDialog}
                                                id="add/update_Owner"
                                                tabIndex="0"
                                                disabled={this.state.btnDisabledc || this.isReadOnly()}
                                            >
                                                {Translations(this.state.pageJson.button_addUpdate.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                                            </button>
                                        }
                                        {this.props.customer ? null :
                                            <button
                                                className="gdocs-btn-default btn-li"
                                                onClick={this.openSendToClientModalDialog}
                                                id="_shareCase"
                                                tabIndex="0"
                                                disabled={this.props.customer || (this.state.sowDocData && this.state.sowDocData[0] &&
                                                    this.state.sowDocData[0].outPutPackURL === undefined ? true : false) || this.state.isCustAck || this.isReadOnly()}
                                            >
                                                <div className="gdocs-btn-with-icon_flex">
                                                    <span className="icon icon-message gdocs-valign-bottom fontsize24 gdocs-pright-10"></span>
                                                    {Translations(this.state.pageJson.button_shareSowCustomer.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                                                </div>
                                            </button>
                                        }
                                        {this.props.customer ? null :
                                            <button
                                                className="gdocs-btn-default btn-li"
                                                onClick={this.openSendToCIModalDialog}
                                                id="_shareCase"
                                                tabIndex="0"
                                                disabled={!this.state.isCustAck || this.props.customer || this.props.sowDetail.assignedTo}
                                            >
                                                <div className="gdocs-btn-with-icon_flex">
                                                    <span className="icon icon-message gdocs-valign-bottom fontsize24 gdocs-pright-10"></span>
                                                    <span>{Translations(this.state.pageJson.button_shareSowCI.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}</span>
                                                </div>
                                            </button>
                                        }
                                    </div>}
                                <button className="gdocs-btn-primary gdocs-btn-wrap btn-li btn-padding"
                                    onClick={this.openSubmitRequestModalDialog}
                                    id={this.isCustomer() ? '_generateDocumentation__customer' : '_generateDocumentation'}
                                    tabIndex="0"
                                    disabled={this.state.btnDisabled || (this.state.sowTabStatus && this.state.sowTabStatus.tab && this.state.sowTabStatus.tab[1].status === 'incomplete') || this.isReadOnly()}
                                >
                                    {Translations(this.state.pageJson.button_generateSowForm.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                                </button>
                            </div>
                        </CaseBodyFooter>
                        <CancelCaseModal
                            showDialog={this.state.showCancelCaseModalDialog}
                            {...this.state.cancelCaseModalPageJson.par}
                            toggleDialog={this.toggleCancelCaseDialog}
                            _onCancelCase={this._onCancelCase}
                            _onChange={this.checkboxStatus}
                            _checked={this.state.checkedvlaue}
                            _setDisabled={!this.state.minNoOfCasesSelected || !this.state.cancelReasonListed}
                            _setRadioSelection={this.setRadioSelection}
                            _entityChecked={this.checkedOptions}
                            _getCases={this.props.cases}
                            _checkedOption={this.state.checkedOptionvalue}
                            _cancelReason={this.state.cancelReason}
                            bsClass="gdocs-cancel-request-modal-content"
                            lang={this.props.lang}
                            sow
                        />
                        {this.props.customer ? null :
                            <AddOwnerModal
                                showDialog={this.state.openAddOwnerModalDialog}
                                toggleDialog={this.toggleDialog}
                                history={this.props.history}
                                customer={this.props.customer}
                                _getSelectedUser={this.getSelectedUser}
                                _displaySelectedUser={this.state.displaySelectedUser}
                                primaryOwner={this.state.userRoll !== undefined ? this.state.userRoll : ''}
                                setListData={this.state.displayUserData}
                                _setOwnerRoll={this.setOwnerRoll}
                                bsClass="send-to-client-modal-content"
                                lang={this.props.lang}
                                formJsonAddOwner={this.state.formJsonAddOwner}
                                _submitOwner={this.submitOwner}
                                _deleteAddedOwner={this.deleteAddedOwner}
                                primaryOwnerText={this.translateWordForRadio(this.state.formJsonAddOwner.par.guideradiobutton_assignRole.options)[0].split('=')[1]}
                                secondaryOwnerText={this.translateWordForRadio(this.state.formJsonAddOwner.par.guideradiobutton_assignRole.options)[1].split('=')[1]}
                                sow
                            />}
                        {
                            this.props.customer ? null :
                                <SendToClientModal
                                    showDialog={this.state.openSendToClientModalDialog}
                                    formJsonClientToSend={this.state.formJsonClientToSend}
                                    toggleDialog={() => this.toggleDialog("_shareCase")}
                                    _sentToClientChecked={this.sentToClientCheckedOptions}
                                    _showCheck={this.state.minNoOfClientCasesSelected}
                                    _resetStateVals={this.state.resetStateVals}
                                    history={this.props.history}
                                    customer={this.props.customer}
                                    cases={this.props.cases}
                                    getFormDataClientToSend={this.getFormDataClientToSend}
                                    onFormSubmitClientToSend={this.onFormSubmitClientToSend}
                                    onFormCancelClientToSend={this.onFormCancelClientToSend}
                                    bsClass="send-to-client-modal-content"
                                    lang={this.props.lang}
                                    sow
                                />}

                        {
                            this.props.customer ? null :
                                <ShareCaseConfirmation
                                    showDialog={this.state.openSendToClientModalConfirmationDialog}
                                    formJsonInviteSent={this.state.formJsonInviteSent}
                                    toggleDialog={this.toggleDialog}
                                    history={this.props.history}
                                    customer={this.props.customer}
                                    getFormDataClientToSend={this.getFormDataClientToSend}
                                    bsClass="send-to-client-modal-content"
                                    lang={this.props.lang}
                                    sow
                                />
                        }
                        {this.props.customer ? null :
                            <SubmitToCheckerModal
                                bsClass="submit-to-checker-modal"
                                showDialog={this.state.openSendToCIModalDialog}
                                toggleDialog={this.toggleSubmitToChekerModal}
                                modalTitle={this.translations(this.state.glsSubmitToCiChecker.page_title_mainTitle && this.state.glsSubmitToCiChecker.page_title_mainTitle.sowPageHeading)}
                                par={this.translations(this.state.glsSubmitToCiChecker.static_text_addANewComment && this.state.glsSubmitToCiChecker.static_text_addANewComment.sowtext1)}
                                label={this.translations(this.state.glsSubmitToCiChecker.static_text_addANewComment && this.state.glsSubmitToCiChecker.static_text_addANewComment.text2)}
                                cancelBtn={this.translations(this.state.glsSubmitToCiChecker.button_addComment && this.state.glsSubmitToCiChecker.button_addComment.text)}
                                submitBtn={this.translations(this.state.glsSubmitToCiChecker.button_done && this.state.glsSubmitToCiChecker.button_done.text)}
                                _onSubmitToChecker={this._onSubmitToChecker}
                            />
                        }

                        {
                            this.props.customer ? null :
                                <AddViewComments
                                    bsClass="comments-modal"
                                    showDialog={this.state.showCommentsModal}
                                    toggleDialog={() => this.setState({ showCommentsModal: false })}
                                    modalTitle={this.translations(this.state.glsApprovalCommentsJson.page_title_mainTitle && this.state.glsApprovalCommentsJson.page_title_mainTitle.sowPageHeading)}
                                    product={{
                                        glsProductType: {},
                                        glsAgent: {},
                                        statusText: "status text"
                                    }}
                                    addCommentLabel={this.translations(this.state.glsApprovalCommentsJson.static_text_addANewComment && this.state.glsApprovalCommentsJson.static_text_addANewComment.title)}
                                    addCommentBtn={this.translations(this.state.glsApprovalCommentsJson.button_addComment && this.state.glsApprovalCommentsJson.button_addComment.text)}
                                    prevCommentsLabel="Previous comments"
                                    comments={this.state.currentProductComments || []}
                                    _onAddComment={this.postComment}
                                    doneBtn={this.translations(this.state.glsApprovalCommentsJson.button_done && this.state.glsApprovalCommentsJson.button_done.text)}
                                    sow
                                    hideFooter
                                />}

                        {
                            this.props.customer ? null :
                                <SubmitRequestModal
                                    showDialog={this.state.showSubmitRequestModalDialog}
                                    {...this.state.productRequestJson}
                                    toggleDialog={() => this.toggleDialog("_generateDocumentation")}
                                    sowDetail={this.props.sowEntities.filter(entity => {
                                        return entity.agent
                                    })[0]}
                                    // cases={this.props.cases || []}
                                    generateDoc={this.props.generateDoc || []}
                                    // _caseSelectedMultiEntity={this._caseSelectedForDraftMultiEntity}
                                    // _caseSelectedSingleEntity={this._caseSelectedForDraftSingleEntity}
                                    _onGenerateDraftClick={this._onGenerateDraftClick}
                                    _onOk={this._onOk}
                                    _enableGenerateDraftBtn={this.state.caseIdsForDraftGeneration}
                                    bsClass="submit-request-modal-content"
                                    _productDetails={this.props.productDetails}
                                    lang={this.props.lang}
                                    sow
                                />}

                        {!isEmptyObject(this.state.documentationConfirmationJson) ? <DraftGenerationSucessModal
                            showDialog={this.state.showDraftGenerationSuccessModal}
                            {...this.state.documentationConfirmationJson}
                            toggleDialog={this.toggleDialog}
                            _onOk={this._onOk}
                            bsClass="draft-generation-ok-modal-content"
                            lang={this.props.lang}
                            sow
                        /> : null}

                    </article>
                </React.Fragment>
            )
        }
        return (<div>{caseBodyJsx}</div>)

    }

}

const mapStateToProps = state => {
    return {
        cases: state.cases,
        generateDoc: state.generateDoc,
        customer: state.auth.userDetails.roleDetails.customer,
        roleDetails: state.auth.userDetails.roleDetails,
        entities: state.entities,
        tabs: state.caseBodyTabsState,
        footerBtnsStatus: state.caseBodyFooterBtnsState,
        _showPreviewAndGenerateDocBtns: state.caseBodyFooterBtnsState.showPreviewAndGenerateDocBtns,
        owningCase: "urn:uuid:c4577fbba69c4b8894796c08975fced6",
        activeTabId: state.caseBodyTabsState.activeTabId,
        productDetails: state.productDetails,
        lang: state.lang,
        token: state.auth.token,
        sowEntities: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || [],
        userDetail: state.auth.userDetails,
        sowId: state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.sowId,
        sowEntitiesFromProductMapping: state.sowEntities && state.sowEntities.entities && state.sowEntities.entities,
        sowDetail: state.sowEntities && state.sowEntities.savedSow,
        activeCustomerAccordionIndex: state.sowBodyReducer.activeCustomerAccordionIndex,
        caseMenu: state.caseMenuInfo,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setDarkTitleBarContent: (...args) => {
            dispatch(setDarkTitleBarContent(...args));
        },
        setCurrentActiveTab: (activeTabId) => {
            dispatch(setCurrentActiveTab(activeTabId));
        },
        enableTab: (tabName) => {
            dispatch(enableTab(tabName));
        },
        showPreviewAndGenerateDocBtns: () => {
            dispatch(showPreviewAndGenerateDocBtns());
        },
        hidePreviewAndGenerateDocBtns: () => {
            dispatch(hidePreviewAndGenerateDocBtns());
        },
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        },
        resetStore: (lang) => {
            dispatch(resetStore(lang))
        },
        caseMenuInfo: caseMenuData => {
            dispatch(caseMenuInfo(caseMenuData))
        },
        setGenrateDoc: (generateDocdata) => {
            dispatch(setGenrateDoc(generateDocdata))
        },
        setCaseOwner: (caseOwner) => {
            dispatch(setCaseOwner(caseOwner))
        },
        setSavedSow: data => {
            dispatch(setSavedSow(data))
        },
        setSowEntities: entities => {
            dispatch(setSowEntities(entities))
        },
        setLandingActiveTab: (activeTabId) => {
            dispatch(setLandingActiveTab(activeTabId));
        },
        setSowBodyCustomerActiveTabIndex: (index) => {
            dispatch(setSowBodyCustomerActiveTabIndex(index))
        },
        resetCaseMenuInfo: () => {
            dispatch(resetCaseMenuInfo())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SowBody)

class OwnerListData {
    constructor(ownerData) {
        this.data = {};
        this.deleteData = {}
    }
    ownerPayLoad = ({ selectedUser, userRoll }) => {
        this.data.userName = selectedUser.name;
        this.data.email = selectedUser.email;
        this.data.primaryOwner = userRoll;
        this.data.psid = selectedUser.userName;
    }
    ownerDelteedPayLoad = ({ email, userName, psid }) => {
        this.deleteData.userName = userName;
        this.deleteData.email = email;
        this.deleteData.psid = psid;
    }
}


class SubmitToCheckerModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValid: false
        };
    }

    handleInputChange = (event) => {
        var inputValid = true;
        var emailAddress = event.target.value;
        if (emailAddress === undefined || emailAddress === '') {
            inputValid = false;
        }
        this.setState({
            emailAddress,
            inputValid
        });
    }

    _onSubmit = () => {
        this.props._onSubmitToChecker(this.state.emailAddress);
    }

    render() {
        return (
            <Modal
                show={this.props.showDialog}
                onClose={this.props.toggleDialog}
                bsClass={this.props.bsClass}
            >
                <ModalHeader title={this.props.modalTitle} />
                <ModalBody>
                    <p>{this.props.par}</p>
                    <label htmlFor="sow-ci-email">{this.props.label}</label>
                    <input type="text" id="sow-ci-email" name="checkerEmail" onChange={this.handleInputChange} />
                </ModalBody>
                <ModalFooter>
                    <button className="gdocs-btn-default"
                        onClick={this.props.toggleDialog}>
                        {this.props.cancelBtn}
                    </button>
                    <button
                        className="gdocs-btn-primary"
                        onClick={this._onSubmit}
                        disabled={!this.state.inputValid}
                    >
                        {this.props.submitBtn}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/SowBody/index.js